import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { OrderIndex, useOrderIndex } from '@hopdrive/feature-order-index';
import type { OrderFeedResult } from '@hopdrive/feature-order-index';

import { useOrderCardActions } from '@features/orderIndex/products/valet/useOrderCardActions';

import type { HomeOrderFeed } from '../hooks/useHomeOrderFeed';

const noop = (): void => {};

export interface HomeOrdersZoneProps extends Pick<HomeOrderFeed, 'resolved' | 'nowMs' | 'preferences'> {
  /** The zone's page slice (already filtered by phase and windowed to the page). */
  feed: OrderFeedResult;
  pageSize: number;
}

/**
 * The pager lives in the section header, so this renders only the cards. Controls are off because
 * Home is today-only. Valet cards get their move-scoped footer from the `ScenarioActionsProvider`
 * this renders inside.
 */
const HomeOrdersZone: React.FC<HomeOrdersZoneProps> = ({ feed, resolved, nowMs, preferences, pageSize }) => {
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('md'));
  const { resolveCardActions, isAssigning, onOpenPhotos } = useOrderCardActions();
  // Each product's write gate from the adapter this renders inside: a read_only Moves product
  // shows its Valet cards with no write controls, as the Orders tab does.
  const { writeControlsAllowed } = useOrderIndex();

  return (
    <OrderIndex
      feed={feed}
      controls={{}}
      viewMode='cards'
      resolved={resolved}
      preferences={preferences}
      nowMs={nowMs}
      pageSize={pageSize}
      pageSizes={[pageSize]}
      resolveCardActions={resolveCardActions}
      isAssigning={isAssigning}
      onOpenPhotos={onOpenPhotos}
      onPageChange={noop}
      onPageSizeChange={noop}
      compact={compact}
      hidePagination
      writeControlsAllowed={writeControlsAllowed}
    />
  );
};

export default HomeOrdersZone;
